/**
 * @module constants
 */

export default {
  UNKNOWN: 0,
  TEMPLATE: 1,
  IMAGE: 2,
  VIDEO: 3,
  POWERCLIPS: 4,
  CHANNEL_BOX: 5,
  CRD: 6
};



// WEBPACK FOOTER //
// ./app/constants/categoryAssetTypes.js